
import React from 'react';
//import './App.css';
//import Navbar from './components/Navbar';
//import Navbar from './components/Navbarelements/index'
import { BrowserRouter as Router, Routes, Route}
    from 'react-router-dom';
   // import Templaterenderer from './components/pages/Templaterenderer';
    //import Subdomainrender from './components/pages/Subdomainrender';
   // import Orderpayment from './components/pages/orderpayment'
    import Invoicepayment from './components/pages/invoicepayment'
    import Orderpayment from './components/pages/orderpaymentpage'
    
    function App() {
      return (
    
          <Router>
        
          <Routes>
              <Route path='/:id' element={<Orderpayment/>}/>
              <Route path='/invoicepayment/:id' element={<Invoicepayment/>}/>
          </Routes>
          </Router>
  );
  }
    
  export default App;